import Joi from 'joi';

export const contactUsValidator = (payload: unknown) => {
  const obj = Joi.object()
    .keys({
      firstName: Joi.string().required(),
      lastName: Joi.string().required(),
      email: Joi.string().required(),
      mobile: Joi.string().required(),
      message: Joi.string().required(),
    })
    .required();

  const { error } = obj.validate(payload);

  return error ? error.details : false;
};
